import React, { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  // Beim ersten Laden prüfen, ob schon akzeptiert wurde
  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  // Akzeptieren und ausblenden
  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-gray-100 p-4 flex flex-col md:flex-row items-center justify-between z-50">
      <p className="text-sm">
        This site uses necessary cookies to ensure you get the best experience.
      </p>
      <button
        onClick={handleAccept}
        className="mt-2 md:mt-0 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-4 rounded"
      >
        Got it!
      </button>
    </div>
  );
}